import React, { useEffect, useState, useRef } from "react";
import { KBD } from "../utils/Keybindings";
import { listen } from "../hooks/Listener";
import { drawPicker } from "../popovers/Picker";
import Space from "../ui/Space";
import Label from "../ui/Label";
import Divider from "../ui/Divider";
import Input from "../ui/Input";
import { VALIDATE } from "../utils/Validators";
import Checkbox from "../ui/Checkbox";
import Status from "../ui/Status";
import { InfoIcon } from "../utils/Icons";
import { addISBNDashes, requireLogin } from "../utils/Utils";
import { pubCall } from "../utils/PubSub";
import { showError } from "../ui/Message";
import NoteTagEditor from "../oneoffs/NoteTagEditor";


export default function InventoryAdjust(props) {

    const { controller = "", signal = {}, route = "", callback = () => { }, stock_data = {}, currentAdjustIndex = "", setCurrentAdjustIndex = () => { } } = props;
    const { primary_code = "", title = "", condition_code = "", minimum_onhand = 0, backroom = 0, total_onhand = 0, stock_id = "" } = stock_data;


    const { note = { full_note: "" } } = stock_data;
    const tagPickerOpen = useRef(false);

    const extractBracketedText = (str) => {

        const ret = str.match(/\[([^\]]+)\]/g);
        if (ret) {
            return ret.map(item => item.slice(1, -1));
        } else {
            return [];
        }
    };

    const notesArr = extractBracketedText(note.full_note);

    useEffect(() => {
        const actions = [
            { key: KBD.ESCAPE, action: (e) => { callback() } },
        ];
        const cleanup = listen(controller, route, actions, false);
        return cleanup;
    }, []);

    const refs = useRef([]);
    const originalValues = useRef({
        minimum_onhand: minimum_onhand,
        backroom: backroom,
        total_onhand: total_onhand,
        reason: "",
        note_tags: "",
        // ...Object.fromEntries(
        //     notesArr.map((item, index) => [`note${index}`, item])
        // )
    });

    const [index, setIndex] = useState(currentAdjustIndex);


    let _arr = [
        { key: "minimum_onhand", value: minimum_onhand },
        { key: "backroom", value: backroom },
        // { key: "total_onhand", value: total_onhand },
        // { key: "reason", value: "" },
        { key: "note_tags", value: "" }
    ]

    notesArr.forEach((item, index) => {
        _arr.push({ key: "note" + index, value: item })
    });
    const [tabs, setTabs] = useState(_arr)

    const update = (_key, value) => {
        let _t = [...tabs];
        setTabs(_t.map(tab => tab.key === _key ? { ...tab, value: value } : tab)
        );
    }

    const getVal = (_key) => {
        return tabs.find(item => item.key === _key).value
    }

    const status = {
        minimum_onhand: <></>,
        backroom: <></>,
        total_onhand: <>Adjust the current ohhand</>,
        note_tags: <>Add/Remove [keyword] to Note. [PgUp] for list.</>
    }


    const editProps = (index) => ({
        onFocus: () => setIndex(index),
        ref: (e) => (refs.current[index] = e),
        edit: true,
        controlled: true,
        autoselect: true,
        onChange: (e) => update(index, e)
    });

    const hasChanged = () => {
        const currentValue = getVal(index);
        const originalValue = originalValues.current[index];
        return currentValue != originalValue;
    };

    const next = () => {
        if (hasChanged() && ["minimum_onhand", "backroom", "reason"].includes(index)) {
            return onEnter();
        }
        const currentIndex = tabs.findIndex(tab => tab.key === index);
        if (currentIndex !== -1 && currentIndex < tabs.length - 1) { return setIndex(tabs[currentIndex + 1].key); }
        return setIndex(tabs[0].key);
    };

    const prev = () => {
        if (hasChanged() && ["minimum_onhand", "backroom", "reason"].includes(index)) {
            return onEnter();
        }
        const currentIndex = tabs.findIndex(tab => tab.key === index);
        if (currentIndex > 0) { return setIndex(tabs[currentIndex - 1].key); }
        return setIndex(tabs[tabs.length - 1].key);
    };

    const saveNote = (_key, _value = null, _stock = stock_data) => {


        const value = ((_value !== null) ? _value : getVal(_key) || "").trim();


        let full_note = note?.full_note || "";

        if (_key === "note_tags") {
            // Add new tag
            if (!value) return;

            const existing = extractBracketedText(full_note);

            if (!existing.includes(value)) {
                full_note = `${full_note}${full_note ? " " : ""}[${value}]`;
            }
        } else if (_key.startsWith("note")) {
            // Edit existing tag
            const noteIndex = parseInt(_key.replace("note", ""), 10);
            let currentIndex = 0;

            full_note = full_note.replace(/\[([^\]]+)\]/g, (match) => {
                if (currentIndex++ !== noteIndex) {
                    return match;
                }
                return value ? `[${value}]` : "";
            });

            full_note = full_note.replace(/\s{2,}/g, " ").trim();
        }

        const updatedStock = {
            ..._stock,
            note: {
                ..._stock.note,
                full_note
            }
        };

        pubCall("stock.edit", { stock: updatedStock }, (_s, _r) => {
            if (_s) {
                if (_key === "note_tags") {
                    update("note_tags", "");
                }

                callback(_r);
            } else {
                showError(_r);
            }
        });
    };


    const showTagPicker = (_key) => {

        if (tagPickerOpen.current) return;
        tagPickerOpen.current = true;

        const _stock = { ...stock_data };

        const value = (getVal(_key) || "").trim();

        pubCall("stock_tag.getTagCounts", {}, (_s, _r) => {

            if (!_s) {
                showError(_r);
                return;
            }

            let options = _r.map(item => {
                return {
                    label: <Space>
                        <div style={{ "width": "40px", "display": "inline", "opacity": "0.5", "textAlign": "left", "borderRight": "1px solid var(--border-secondary)" }}>
                            <small>{item.count}</small>
                        </div>
                        <div>{item.tag}</div>
                    </Space>,
                    value: item.tag
                }
            });

            // If this tag doesn't exist, insert it alphabetically
            if (value && !options.some(item => item.value.toUpperCase() === value.toUpperCase())) {

                options.push({
                    label: <Space>
                        <div style={{ "width": "40px" }} />
                        <div>{value} <small className="text-light">new</small></div>
                    </Space>,
                    value: value
                });

                options.sort((a, b) => a.value.localeCompare(b.value));
            }

            drawPicker({
                controller: controller,
                showSearch: true,
                searchValue: true,
                value: value,
                title: "Tag",
                closeable: true,
                height: 300,
                route: route,
                options: options,
                callback: (_value) => {
                    tagPickerOpen.current = false;
                    if (_value) {
                        update(_key, _value);
                        saveNote(_key, _value, _stock);
                    }
                },
                close: () => {
                    tagPickerOpen.current = false;
                    refs.current[_key]?.focus();
                },
                offset: [0, 10]
            });
        });
    };

    const onEnter = () => {
        if (tagPickerOpen.current) return;
        setCurrentAdjustIndex(index);

        // remove if you clear the field
        if (index.startsWith("note") && !getVal(index)?.trim()) {
            saveNote(index, "");
            setIndex("note_tags");
            setCurrentAdjustIndex("note_tags");
            return;
        }


        if (index === "note_tags" || index.startsWith("note")) {
            showTagPicker(index);
            return;
        }


        switch (index) {
            case "minimum_onhand":
                let _moh = getVal("minimum_onhand") || 0;
                requireLogin({
                    route: route, signal: signal, callback: (e) => {
                        pubCall("stock.adjustMinimumOnhand", { quantity: _moh, stock_id: stock_id }, (_s, _r) => {
                            if (_s) {
                                callback(_r);
                            } else {
                                showError(_r);
                            }
                        })

                    }
                })
                break;
            case "backroom":
                let _br = getVal("backroom") || 0;
                pubCall("stock.adjustBackroom", { quantity: _br, stock_id: stock_id }, (_s, _r) => {
                    if (_s) {
                        callback(_r);
                    } else {
                        showError(_r);
                    }
                })
                break;
            case "total_onhand":
                next();
                break;
            case "reason":
                setCurrentAdjustIndex("total_onhand");
                requireLogin({
                    route: route, signal: signal, permission: "adjust_onhand", callback: (e) => {

                        let _toh = getVal("total_onhand") || 0;
                        let _reason = getVal("reason") || ""
                        pubCall("stock.adjustOnhand", { quantity: _toh, reason: _reason, stock_id: stock_id }, (_s, _r) => {
                            if (_s) {
                                callback(_r);
                            } else {
                                showError(_r);
                            }
                        })

                    }
                })


                break;


        }
    }

    // Keyboard Events
    useEffect(() => {

        if (refs?.current[index]) {
            refs.current[index].focus();
        }

        const actions = [
            { key: KBD.ARROW_DOWN, action: (e) => next() },
            { key: KBD.ARROW_UP, action: (e) => prev() },
            { key: KBD.TAB, action: (e) => { next() } },
            { key: KBD.SHIFT_TAB, action: (e) => { prev() } },
            { key: KBD.ESCAPE, action: (e) => callback(false) },
            { key: KBD.ENTER, action: (e) => { onEnter() } },
            { key: KBD.PAGE_DOWN, action: (e) => { onEnter() } }
        ];
        const cleanup = listen(controller, route, actions, (e) => {
            if (e.deltaY > 0) {
                next();
            } else {
                prev();
            }
        }, [KBD.ARROW_DOWN, KBD.ARROW_UP, KBD.TAB, KBD.SHIFT_TAB, KBD.ESCAPE, KBD.ENTER, KBD.PAGE_UP, KBD.PAGE_DOWN, KBD.CTRL_C, KBD.CTRL_V], [], [KBD.CTRL_C, KBD.CTRL_V]);
        return cleanup;
    }, [index, tabs, update]);




    return (<>
        <div className="shim" /><div className="shim" /><div className="shim" />
        <div >

            <Space height={25} size={10}>
                <Label width={110}>ISBN</Label><Divider vertical />
                {addISBNDashes(primary_code, condition_code)}
            </Space>

            <Space height={25} size={10}>
                <Label width={110}>Title</Label><Divider vertical />
                {title}
            </Space>

            <div className="shim" /><div className="shim" /><div className="shim" />
            <Space height={25} size={10}>
                <Label width={110}>Min O/H</Label><Divider vertical />
                <Input {...editProps("minimum_onhand")} maxLength={3} number number_default={null} autoselect placeholder="" width={50} edit value={getVal("minimum_onhand")} />
            </Space>
            <div className="shim" />
            <Space height={25} size={10}>
                <Label width={110}>Backroom</Label><Divider vertical />
                <Input {...editProps("backroom")} maxLength={3} number number_default={null} autoselect placeholder="" width={50} edit value={getVal("backroom")} />
            </Space>
            <div className="shim" />
            <Space height={25} size={10}>
                <Label width={110}>On Hand</Label><Divider vertical />
                {/* <Input {...editProps("total_onhand")} maxLength={3} number number_default={null} autoselect placeholder="" width={50} edit value={getVal("total_onhand")} /> */}
                <Input className="dim" maxLength={3} number number_default={null} autoselect placeholder="" width={50} />
                <Label width={55}>Reason</Label><Divider vertical />
                {/* <Input {...editProps("reason")} maxLength={10} autoselect placeholder="" width={150} edit value={getVal("reason")} /> */}
                <Input className="dim" maxLength={10} autoselect placeholder="" width={150} />

            </Space>

            <Divider align="left"><Label>Keyword Tags in Note</Label></Divider>


            <div className="shim" />
            <Space height={25} size={10}>
                <Label width={40}>New</Label><Divider vertical />
                <Input {...editProps("note_tags")} maxLength={6} autoselect placeholder="" width={75} edit value={getVal("note_tags")} />

                <NoteTagEditor controller={controller} editProps={editProps} notesArr={notesArr} note={note.full_note} />
            </Space>


            <div className="shim" /><div className="shim" />
            <Status><InfoIcon /> {status[index]}</Status>
        </div>

    </>)

}